import { GameSettings } from "./types";
import { contentTypeIds } from "../types";

export const boombeach: GameSettings = {
  enabledTabs: ["news", "community", "blog"],
  enabledLocales: ["en"],
  enabledNotificationTypes: ["standard"],
  referenceWidth: 993,
  availableButtonVariants: ["blue"],
  availableCategories: [
    {
      name: { en: "Activity" },
      id: "activity",
      color: "#50418c",
    },
    {
      name: { en: "News" },
      id: "news",
      color: "#50418c",
    },
    {
      name: { en: "Blog" },
      id: "blog",
      color: "#379348",
    },
    {
      name: { en: "Updates" },
      id: "updates",
      color: "#007ecc",
    },
    {
      name: { en: "Events" },
      id: "events",
      color: "#50388c",
    },
    {
      name: { en: "Strategy" },
      id: "strategy",
      color: "#1b7f85",
    },
    {
      name: { en: "Community" },
      id: "community",
      color: "#eb8a4b",
    },
  ],

  enabledComposePages: ["news", "events"],

  resolutions: {
    [contentTypeIds.newsEntryExternalLink]: {
      linkThumbnail: {
        width: 900,
        height: 493,
      },
    },
    [contentTypeIds.newsEntryArticle]: {
      heroImage: {
        width: 1950,
        height: 650,
        fit: "default",
      },
      largeThumbnail: {
        width: 900,
        height: 493,
      },

      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },
    [contentTypeIds.smallNewsEntryExternalLink]: {
      linkThumbnail: {
        width: 880,
        height: 880,
      },
    },
    [contentTypeIds.smallNewsEntryArticle]: {
      heroImage: {
        width: 1950,
        height: 650,
        fit: "default",
      },
      smallThumbnail: {
        width: 880,
        height: 880,
      },

      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },
    [contentTypeIds.videoBlock]: {
      videoThumbnail: {
        width: 900,
        height: 493,
      },
    },
    [contentTypeIds.pollBlock]: {
      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },
    [contentTypeIds.carouselEventPollEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
      },
      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },
    [contentTypeIds.newsEntryVideo]: {
      videoThumbnail: {
        width: 900,
        height: 493,
      },
    },
    [contentTypeIds.imageBlock]: {
      image: null,
    },
    [contentTypeIds.featureBlock]: {
      featureThumbnail: {
        width: 700,
        height: 700,
      },
    },
    [contentTypeIds.carouselEventEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
      },
    },

    [contentTypeIds.carouselEventProgressTrackerEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
      },
      milestone1Image: {
        width: 256,
        height: 256,
      },
      milestone2Image: {
        width: 256,
        height: 256,
      },
      milestone3Image: {
        width: 256,
        height: 256,
      },
      milestone4Image: {
        width: 256,
        height: 256,
      },
      milestone5Image: {
        width: 256,
        height: 256,
      },
      milestone6Image: {
        width: 256,
        height: 256,
      },
      milestone7Image: {
        width: 256,
        height: 256,
      },
      milestone8Image: {
        width: 256,
        height: 256,
      },
    },

    [contentTypeIds.communityCreator]: {
      communityCreatorThumbnail: {
        width: 50,
        height: 50,
      },
    },

    [contentTypeIds.communityVideoEntry]: {
      communityEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.communityLivestreamEntry]: {
      livestreamEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.newsEntryImage]: {
      imageNewsThumbnail: {
        width: 900,
        height: 493,
      },
    },
  },

  blogMeta: {
    site: "Boom Beach",
    creator: "@BoomBeach",
  },

  activeContentInDays: {
    community: 90,
    news: 90,
  },

  supportPolls: true,
  supportTargetPolls: false,
  supportProgressTrackerEntry: false, // Before enabling this, check the design
  targetingFields: ["country", "countryExclude", "platform", "campaignId"],
  notifyOnNewCommunityContent: true,
};
